export enum DocumentTypeFullEnum {
    HASCHIP = 'UY_CI_E' as any,
    NOTHASCHIP = 'UY_CI_P' as any
}
